import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {CommunicationContentModelSummaryModel} from '../communicationContentModelSummary.model';

@Injectable()
export class CommunicationContentModelSummaryConverter extends HttpModelConverter<CommunicationContentModelSummaryModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }
    protected createInstance(): CommunicationContentModelSummaryModel {
        return new CommunicationContentModelSummaryModel();
    }

    protected enrichObject(result: CommunicationContentModelSummaryModel, src: CommunicationContentModelSummaryModel) {
        result.type = this.lovValueSummaryConverter.convert(src.type);
    }
}
